import React from "react";
import { motion } from "framer-motion";

const items = [
  "Ind AS 116 Compliant",
  "IFRS 16 Ready",
  "Black-Scholes Engine",
  "IBBI Framework",
  "Bcrypt + CSRF Hardened",
  "CA Built & Reviewed",
  "Excel-Native Workflow",
  "Multi-Tenant",
  "Audit Trail Immutable",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <section
      className="relative border-y border-black/10 bg-white py-6 overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      <motion.div
        className="flex gap-12 whitespace-nowrap animate-marquee w-max"
        data-testid="marquee-track"
      >
        {loop.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-3 font-display text-2xl md:text-3xl text-[#202A36]/80"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            {t}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
